import React, { Component } from 'react';
import Vas from '../../Vas';
//import '../css/CustomerCreateContract.css';
import { LinkButton } from 'component-lib';

class CreateCustomerSuccess extends Component
{

  constructor(props)
  {
    super(props);
    this.state = {};
  }
 
  Cancel(){
    Vas.GetView("Customers",null, true);
  }
  render()
  {
    
    return (
      <div className={"PaymentContainer"}>
      <div className={"form"}>
        <table >
          <thead>
            <tr>
              <th style={{fontSize:'large',width:'400px'}} colSpan={2}>
                {Vas.Resources.Labels["CreateCustomerSuccess"]}
                <br />
                <br />
              </th>
            </tr>
          </thead>
        <tbody>
          <tr></tr>
          <tr>
          <td style={{ width:'265px', fontSize:'14px', textAlign: 'right' }}>{Vas.Resources.Labels["LinkLoginFemininum"]}</td>
              <td style={{ textAlign: 'left' }}>
                <LinkButton 
                Text={Vas.Resources.Labels["EmployeeOverview"]} 
                Id={"LinkLogin"} 
                OnClick={()=>{this.Cancel();}}
              />
              </td>
          </tr>
        </tbody>
      </table>
      </div>
      </div>
    );
  }
}
export default CreateCustomerSuccess;
